import { database, ref, set } from "../../FirebaseConfig";

export const saveTransactionAbonnement = async (paymentId, amount, idVendeur,idGroupe,duration,idClient,key) => {
  // Crée une référence à l'emplacement spécifique dans la base de données
  const transactionRef = ref(database, `transaction-abonnement/${paymentId}`);

  // Données à insérer
  const data = {
    amount: Number(amount),
    status: 'pending',
    idVendeur,
    idClient,
    idGroupe,
    duration,
    idProduit:paymentId,
    key:key,

    created_at: new Date().toISOString()
  };

  try {
    // Insérer les données
    await set(transactionRef, data);
    console.log("Transaction sauvegardée avec succès");
  } catch (error) {
    console.error("Erreur lors de la sauvegarde de la transaction:", error);
    throw error;
  }
};